module.exports = __webpack_public_path__ + "static/media/dashboardlogo.68708ed3.png";